// extracted by mini-css-extract-plugin
module.exports = {"avatarWrapper":"UserAvatar_avatarWrapper__QIr_9","withIcon":"UserAvatar_withIcon__Ds5G9","big":"UserAvatar_big__HqWmT","avatar":"UserAvatar_avatar__SUA3F"};